import { useMassIncidentUi } from '../model/store';
import { MassIncidentPanel } from './MassIncidentPanel';
import { MassIncidentPicker } from './MassIncidentPicker';
import { MassReplyDialog } from './MassReplyDialog';

export const MassIncidentHost: React.FC = () => {
  const panel = useMassIncidentUi((s) => s.panel);
  const picker = useMassIncidentUi((s) => s.picker);
  const reply = useMassIncidentUi((s) => s.reply);
  const close = useMassIncidentUi((s) => s.close);
  return (
    <>
      {panel && (
        <MassIncidentPanel key={panel.incidentId} incidentId={panel.incidentId} onClose={() => close('panel')} />
      )}
      {picker && <MassIncidentPicker request={picker} onClose={() => close('picker')} />}
      {reply && (
        <MassReplyDialog
          key={reply.incidentId}
          incidentId={reply.incidentId}
          sourceTicketId={reply.sourceTicketId}
          onClose={() => close('reply')}
        />
      )}
    </>
  );
};
